import AppointmentOutcomeEnum from '../enums/AppointmentOutcomeEnum';

interface OutcomeOption {
  value: AppointmentOutcomeEnum;
  label: string;
}

/**
 * Os rotulos das 5 categorias de desfecho, na ordem em que a
 * `taxonomia-desfecho-atendimento.md` as apresenta.
 *
 * ⚠️ **As cinco aparecem sempre**, mesmo as duas que o back recusa em certos casos
 * ("Falso alerta" so vale para atendimento originado de alerta; "Atendimento de
 * rotina" so para atendimento sem alerta). Filtrar aqui exigiria a tela saber se ha
 * alerta vinculado -- informacao que ela nao tem no momento de montar o formulario --
 * e esconder uma opcao dependendo de estado invisivel confunde mais do que a recusa,
 * que vem com mensagem explicando o motivo.
 */
export const APPOINTMENT_OUTCOME_OPTIONS: OutcomeOption[] = [
  {
    value: AppointmentOutcomeEnum.RESOLVED_BY_CINCO,
    label: 'Resolvido pela CINCO',
  },
  {
    value: AppointmentOutcomeEnum.REFERRED_TO_EMERGENCY,
    label: 'Encaminhado a SAMU/UPA',
  },
  {
    value: AppointmentOutcomeEnum.FALSE_ALERT,
    label: 'Falso alerta / sem necessidade de conduta',
  },
  {
    value: AppointmentOutcomeEnum.PATIENT_NOT_FOUND,
    label: 'Paciente não localizado',
  },
  {
    value: AppointmentOutcomeEnum.ROUTINE_COMPLETED,
    label: 'Atendimento de rotina concluído',
  },
];

export default function getAppointmentOutcomeLabel(
  outcome?: AppointmentOutcomeEnum | null,
): string {
  return (
    APPOINTMENT_OUTCOME_OPTIONS.find((option) => option.value === outcome)
      ?.label ?? '—'
  );
}
